import { List } from 'immutable';
export var initialState = List();
/**
 * Redux reducer for managing pending-actions state
 *
 * @param {Object} state - current app state
 * @param {Object} action - processing action
 * @return {Object} state - new app state
 */

export default function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  if (!(state instanceof List)) return initialState.mergeDeep(state);

  switch (action.type) {
    case 'ADD_PENDING_ACTION':
      {
        var actionName = action.payload.actionName;
        return state.push(actionName);
      }

    case 'REMOVE_PENDING_ACTION':
      {
        var _actionName = action.payload.actionName;
        var index = state.indexOf(_actionName);
        if (index !== -1) return state.delete(index);
      }
  }

  return state;
}